import React from "react";
import styled from "styled-components";
import UserAvatar from "../../../components/UserAvatar";
import { Colors, TextFont } from "../../../config";
import AirportDetail from "./AirportDetail";
import BaggageDetail from "./BaggageDetail";

const timeClock = require("../../../assets/images/Time Circle.png");
const rightArrow = require("../../../assets/images/rightArrow.png");

const EachViewDetails = ({ flightName, imgSrc }) => {
  return (
    <>
      <DetailsHeader>
        <DetailsTab>
          <TextFont fontColor={Colors.brandOne} fontSize="0.75rem">
            QATAR(DOH) &nbsp;
            <span>
              <img src={rightArrow} alt="->" />
            </span>
            &nbsp; DUBAI(DXB)
          </TextFont>
          <TextFont fontColor={Colors.sharkOpacity50} fontSize="0.75rem">
            Sun, 24 feb
          </TextFont>
        </DetailsTab>
      </DetailsHeader>
      <DetailsBody>
        <NameWrapper>
          <UserAvatar
            userName={flightName}
            imgSrc={imgSrc}
            bgdColor={Colors.white}
          />
          <MainLabel>{flightName}</MainLabel>
          <Sublabel>100981</Sublabel>
          <Sublabel>Economy</Sublabel>
        </NameWrapper>
        <AirportDetail
          place={"DOH"}
          time={"10:05"}
          date={"Mon, 24 Apr 2023"}
          airport={"Doha International Airport, Inc"}
        />
        <CenterAlign>
          <CenterAlign gap="0.5rem">
            <img src={timeClock} alt="clock" />
            <MainLabel>1h 0m</MainLabel>
          </CenterAlign>
        </CenterAlign>
        <AirportDetail
          place={"SHJ"}
          time={"12:05"}
          date={"Mon, 24 Apr 2023"}
          airport={"Sharjah, TerminalX"}
        />
        <BaggageDetails>
          <BaggageDetail
            heading={"CheckIn Baggage:"}
            quantity={"40kg/Person"}
          />
          <BaggageDetail heading={"Cabin Baggage:"} quantity={"7kg/Person"} />
        </BaggageDetails>
      </DetailsBody>
    </>
  );
};

export default EachViewDetails;

const DetailsHeader = styled.div`
  background: ${Colors.linkWater};
`;
const DetailsTab = styled.div`
  width: calc(100% - 2rem);
  padding: 0.75rem 1rem;
  display: flex;
  gap: 1rem;
`;
const DetailsBody = styled.div`
  padding: 1rem 1.25rem;
  display: flex;
  justify-content: space-between;
`;
const NameWrapper = styled.div`
  display: flex;
  flex-direction: Column;
  align-items: center;
  gap: 0.25rem;
`;
export const MainLabel = styled.div`
  color: ${Colors.sharkApprox};
  font-size: 0.875rem;
  font-weight: 600;
`;
export const Sublabel = styled.div`
  color: ${Colors.bombay};
  font-size: 0.875rem;
  font-weight: 600;
`;
const CenterAlign = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${(props) => props.gap && props.gap};
`;
const BaggageDetails = styled.div`
  padding-top: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
